module.exports = __webpack_public_path__ + "img/estagio_nao_obrigatorio.9cb01de8.svg";